import { Sector } from '../model/sector';
import { isTransport } from '../functions/type-guards/is-transport';
import { isOther } from '../functions/type-guards/is-other';
import { isEnergy } from '../functions/type-guards/is-energy';
import { isAgriculture } from '../functions/type-guards/is-agriculture';
import { isIndustry } from '../functions/type-guards/is-industry';
import { TransitionElement } from '../model/enums/transition-element';

export function transitionElementToSector(te: TransitionElement | undefined): Sector {
  if (te === undefined) {
    return Sector.None;
  }
  if (isTransport(te)) {
    return Sector.Transport;
  }
  if (isIndustry(te)) {
    return Sector.Industry;
  }
  if (isAgriculture(te)) {
    return Sector.Agriculture;
  }
  if (isEnergy(te)) {
    return Sector.Energy;
  }
  if (isOther(te)) {
    return Sector.Other;
  }
  return Sector.None;
}
